import cx from 'classnames';
import React from 'react';
import { useId } from '../hooks/use-id.js';
export const SwitchToggle = ({ ariaLabel = 'Toggle Button', className, disabled, falseLabel, id, inputRef, labelInside, toggleSize, trueLabel, ...rest }) => {
    const uId = useId();
    const htmlId = id || uId;
    return (React.createElement("label", { "aria-label": ariaLabel, className: cx('tds-switch_toggle', {
            'tds--disabled': disabled,
            'tds-switch_toggle--label_inside': labelInside,
            [`tds-switch_toggle--${toggleSize}`]: toggleSize,
        }, className), htmlFor: htmlId },
        React.createElement("input", { ...rest, className: "tds-switch_toggle-checkbox", disabled: disabled, id: htmlId, ref: inputRef, type: "checkbox" }),
        React.createElement("span", { "aria-hidden": "true", className: "tds-switch_toggle-track" }),
        React.createElement("span", { "aria-hidden": "true", className: "tds-switch_toggle-btn" }, labelInside ? trueLabel : falseLabel),
        React.createElement("span", { "aria-hidden": "true", className: "tds-switch_toggle-btn" }, labelInside ? falseLabel : trueLabel)));
};
